// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3hKGe","row":"styles_row__12Mch"};